import React, { useState } from "react";
import { useMediaQuery } from "@mui/material";
import HeaderUnreadButtons from "./HeaderUnreadButtons";
import UnreadModalMobile from "./UnreadModalMobile";
import UnreadModalPC from "./UnreadModalPC";

export default function Unread({
  projectIndexUrl,
  jobIndexUrl,
  unreadProjects,
  unreadJobs,
  projectUnreadCount,
  jobUnreadCount,
}) {
  // 未読バッジ表示用の合計件数
  const totalUnreadCount = projectUnreadCount + jobUnreadCount;

  // モーダルの表示状態・表示中のタブ　初期表示はプロジェクト
  const [activeType, setActiveType] = useState("projects");
  const [open, setOpen] = useState(false);

  // PC用：クリックされたタブをそのまま開く
  const onOpenPC = (type) => {
    setActiveType(type);
    setOpen(true);
  };

  // モバイル用：未読がある方を初期表示
  const onOpenMobile = () => {
    if (projectUnreadCount > 0) {
      setActiveType("projects");
    } else if (jobUnreadCount > 0) {
      setActiveType("jobs");
    } else {
      setActiveType("projects");
    }
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const onChangeActiveType = (type) => {
    if (type) {
      setActiveType(type);
    }
  };

  const isDesktop = useMediaQuery("(min-width:768px)");

  return (
    <div className="Unread">
      <HeaderUnreadButtons
        isDesktop={isDesktop}
        onOpen={isDesktop ? onOpenPC : onOpenMobile}
        projectUnreadCount={projectUnreadCount}
        jobUnreadCount={jobUnreadCount}
        totalUnreadCount={totalUnreadCount}
      />
      {isDesktop ? (
        <UnreadModalPC
          open={open}
          onClose={onClose}
          activeType={activeType}
          unreadProjects={unreadProjects}
          unreadJobs={unreadJobs}
          projectIndexUrl={projectIndexUrl}
          jobIndexUrl={jobIndexUrl}
        />
      ) : (
        <UnreadModalMobile
          open={open}
          onClose={onClose}
          activeType={activeType}
          onChangeActiveType={onChangeActiveType}
          unreadProjects={unreadProjects}
          unreadJobs={unreadJobs}
          projectIndexUrl={projectIndexUrl}
          jobIndexUrl={jobIndexUrl}
          projectUnreadCount={projectUnreadCount}
          jobUnreadCount={jobUnreadCount}
        />
      )}
    </div>
  );
}
